export default __webpack_public_path__ + "static/media/90s_column.be220ecf.png";